import { modifyState } from '~src/state';
import { updateObjectShadow } from '~src/sidebar/index';

export const onShadowChangeColor = (event) => {
  event.preventDefault();
  modifyState('setShadowColorActive', true);
  updateObjectShadow();
};
